const currentEnv = process.env.VUE_APP_ENV;
const targetEnv = 'production';
import {triggerTrackingEvent} from "@/common/helpers";

const mixins = {
    data() {
        return {
            speedTrackingShowroom: null,
            speedTrackingDocuments: null,
        }
    },
    beforeDestroy () {
        this.$bus.$off('speedTrackingShowroom')
    },
    methods: {
        speedTrackingShowroomTrigger(type, identifier, name){
            if(currentEnv === targetEnv) {
                this.$bus.$on('speedTrackingShowroom', (endTime) => {
                    const elapsedTime = (endTime - this.speedTrackingShowroom);
                    //console.log(`Load showroom (${type}) : ${elapsedTime}`)
                    const typeKey = (type === 'accessoire' ? 'accessory' : type);
                    /*gtag('event', 'showroom_done_loading', {
                        'event_category': 'performance',
                        'event_label': `Durée de chargement d'un showroom (premier slide seulement)`,
                        'value': elapsedTime
                    });
                    gtag('event', `showroom_${typeKey}_done_loading`, {
                        'event_category': 'performance',
                        'event_label': `Durée de chargement du showroom (premier slide seulement) d'une fiche ${type}`,
                        'value': elapsedTime
                    });
                    gtag('event', `showroom_${typeKey}_${identifier}_done_loading`, {
                        'event_category': 'performance',
                        'event_label': `Durée de chargement du showroom (premier slide seulement) de la fiche ${type} : ${name}`,
                        'value': elapsedTime
                    });*/

                    // triggerTrackingEvent('showroom_done_loading', 'performance', `Durée de chargement d'un showroom (premier slide seulement)`, elapsedTime)
                    // triggerTrackingEvent(`showroom_${typeKey}_done_loading`, 'performance', `Durée de chargement du showroom (premier slide seulement) d'une fiche ${type}`, elapsedTime)
                    // triggerTrackingEvent(`showroom_${typeKey}_${identifier}_done_loading`, 'performance', `Durée de chargement du showroom (premier slide seulement) de la fiche ${type} : ${name}`, elapsedTime)
                });
            }
        },
        speedTrackingDocumentsTrigger(type, identifier, name){
            if(currentEnv === targetEnv) {
                const currentTime = new Date().getTime();
                const elapsedTime = (currentTime-this.speedTrackingDocuments);
                //console.log(`Load documents (${type}) : ${elapsedTime}`)
                const typeKey = (type === 'accessoire' ? 'accessory' : type);
                /*gtag('event', 'documents_done_loading', {
                    'event_category': 'performance',
                    'event_label': `Durée de chargement des documents`,
                    'value': elapsedTime
                });
                gtag('event', `documents_${typeKey}_done_loading`, {
                    'event_category': 'performance',
                    'event_label': `Durée de chargement des documents${(type === 'machine' ? '(walkaround, reduce risks & documents)' : '')} d'une fiche ${type}`,
                    'value': elapsedTime
                });
                gtag('event', `documents_${typeKey}_${identifier}_done_loading`, {
                    'event_category': 'performance',
                    'event_label': `Durée de chargement des documents ${(type === 'machine' ? '(walkaround, reduce risks & documents)' : '')} de la fiche ${type} : ${name}`,
                    'value': elapsedTime
                });*/

                // triggerTrackingEvent('documents_done_loading', 'performance', `Durée de chargement des documents`, elapsedTime)
                // triggerTrackingEvent(`documents_${typeKey}_done_loading`, 'performance', `Durée de chargement des documents${(type === 'machine' ? '(walkaround, reduce risks & documents)' : '')} d'une fiche ${type}`, elapsedTime)
                // triggerTrackingEvent(`documents_${typeKey}_${identifier}_done_loading`, 'performance', `Durée de chargement des documents ${(type === 'machine' ? '(walkaround, reduce risks & documents)' : '')} de la fiche ${type} : ${name}`, elapsedTime)
            }
        },
        speedTrackingAutocompleteProductTrigger(startTime, name, selectedItem){
            // if(currentEnv === targetEnv) {
                const currentTime = new Date().getTime();
                const elapsedTime = (currentTime-startTime);
                //console.log(`Search autocomplete (${name}) : ${elapsedTime}`)
                /*gtag('event', 'keyword_search_autocomplete_done_loading', {
                    'event_category': 'performance',
                    'event_label': `Durée de chargement de l'autocomplétion pour le terme [${name}]`,
                    'value': elapsedTime
                });*/

                // triggerTrackingEvent('keyword_search_autocomplete_done_loading', 'performance', `Durée de chargement de l'autocomplétion pour le terme [${name}]`, elapsedTime)
                triggerTrackingEvent('search', `${name}`, `${selectedItem.name}`, elapsedTime)
            // }
        },
    }
};

export default mixins;